/** Имя UXFB-события применения фильтра. Должно побайтово совпадать с кампаниями в админке UXFB. */
export const UXFB_EVENT_SERP_FILTER_APPLIED = 'serp_filter_applied';

/**
 * Kill-switch клиентских UXFB-событий. По умолчанию события включены; выключаются значением `false`
 * в конфиге (`uxfeedback.clientEvents.enabled`).
 */
export const UXFB_CLIENT_EVENTS_CONFIG_KEY = 'uxfeedback.clientEvents.enabled';
